import { http } from '@/http'

export default {
  list(params) {
    return http.get('/channels', { params })
  },
  listActive() {
    return http.get('/channels/active')
  },
  get(id) {
    return http.get(`/channels/${id}`)
  },
  save(data) {
    return http.post('/channels', data)
  },
  update(id, data) {
    return http.put(`/channels/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/channels/${id}/status`, null, { params: { status } })
  },
}
